/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ExceptionInfo, HttpRequestsLogs, LogMessages } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FrontendLoggingClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags FrontendLogging
   * @summary Отображение ошибки стека исключений
   * @request POST:/bff/FrontendLogging/error
   * @secure
   */
  frontendLoggingProcessException = (data: ExceptionInfo, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/bff/FrontendLogging/error`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags FrontendLogging
   * @summary Отображение вывода консоли
   * @request POST:/bff/FrontendLogging/console
   * @secure
   */
  frontendLoggingProcessConsole = (data: LogMessages, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/bff/FrontendLogging/console`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags FrontendLogging
   * @summary Отображение информации о сетевом фронтовом запросе
   * @request POST:/bff/FrontendLogging/network
   * @secure
   */
  frontendLoggingProcessNetwork = (data: HttpRequestsLogs, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/bff/FrontendLogging/network`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
}
